<template>
  <div class="app-container" v-loading="listLoading">
    <el-row style="padding-top: 10px; margin-bottom: 20px;">
      <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
        <el-card class="box-card">
          <div>NZD - 电子钱包</div>
          <div style="padding-top: 10px; font-size: 26px; font-weight: bold;">${{ balance }} NZD</div>
          <el-row>
            <el-col :span="16">
              <!-- <div style="padding-top: 10px;">总余额: $0.00</div> -->
              <div style="padding-top: 15px;">可提现余额: ${{ can_withdrawal_balance }}</div>
            </el-col>
            <el-col :span="8">
              <div style="float: right; margin-top: 10px;">
                <el-button size="small" type="primary" plain @click="withdrawDialogVisible = true">申请提现</el-button>
              </div>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>
    <p style="font-size: 14px; color: red;">最低提现金额为NZD $50</p>
    <p><b>钱包流水</b></p>
    <el-table
      :data="walletTransactionData"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
      style="margin-bottom: 20px;">
      <el-table-column :label="generateCustomizeString('orderCreateAt')" prop="created_at">
      </el-table-column>
      <el-table-column label="类型" prop="source_name">
      </el-table-column>
      <el-table-column label="流水号" prop="transaction_no">
      </el-table-column>
      <el-table-column label="金额" prop="amount" width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.source_name === '提现'">- </span>
          <span v-else>+ </span>
          {{ scope.row.amount | formatPrice }}
        </template>
      </el-table-column>
      <el-table-column label="余额" prop="balance" width="120">
        <template slot-scope="scope">
          <div>{{ scope.row.balance | formatPrice }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="generateCustomizeString('operation')">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="clickView(scope.row)" v-if="scope.row.source_name === '提现'">{{ generateCustomizeString('view') }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-footer style="margin-top: 50px; width: 100%;">
      <el-row type="flex">
        <el-col>
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="numOfMembers"
            :total="currentTotal"
            small
            background
            layout="prev, pager, next"
            v-if="isMobile === true">
          </el-pagination>
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="numOfMembers"
            :total="currentTotal"
            background
            layout="total, prev, pager, next"
            v-else>
          </el-pagination>
        </el-col>
      </el-row>
    </el-footer>

    <el-dialog :visible.sync="viewDetailsDialogVisible" title="提现详情" style="margin-bottom: 20px;" v-loading="uploadLoading">
      <div class="grid-content">
        <span class="title-label">状态: </span>
        <span class="content-label">{{ walletWithdrawalDetails.status_name }}</span>
      </div>
      <div style="min-height: 30px; margin: 0 auto;">
        <el-radio v-model="walletWithdrawalDetails.currency_type" :label="walletWithdrawalDetails.currency_type">{{ walletWithdrawalDetails.currency_type_name }}</el-radio>
      </div>
      <div class="grid-content">
        <span class="title-label">提现金额: </span>
        <span class="content-label">NZD ${{ parseFloat(walletWithdrawalDetails.amount / 100).toFixed(2) }}</span>
      </div>
      <div class="grid-content">
        <span class="title-label">提现银行: </span>
        <span class="content-label">{{ walletWithdrawalDetails.channel_name }}</span>
      </div>
      <div class="grid-content">
        <span class="title-label">提现账户: </span>
        <span class="content-label">{{ walletWithdrawalDetails.account }}</span>
      </div>
      <div class="grid-content">
        <span class="title-label">持卡人: </span>
        <span class="content-label">{{ walletWithdrawalDetails.account_name }}</span>
      </div>
      <div>
        <div>上传文件</div>
        <el-row style="margin: 10px 0;">
          <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6" v-for="(item, index) in walletWithdrawalDetails.images" :key="index" style="margin:.3%">
            <el-card :body-style="{ padding: '0px'}">
              <div>
                <img :src="item.image_url + '&imageView2/0/w/350/h/350/q/75|imageslim'" style="width: 100%;">
              </div>
              <!-- <div style="padding: 2px;">
                <div>
                  <el-button type="text" class="button" @click="delClick(index)">删除文件</el-button>
                </div>
              </div> -->
            </el-card>
          </el-col>
        </el-row>

        <el-upload :data="qiniuData" :limit="5" :on-success="handleAvatarSuccess" :on-error="handleError" :before-upload="beforeAvatarUpload" action="https://upload-z2.qiniup.com" :show-file-list="false" multiple v-if="walletWithdrawalDetails.images && walletWithdrawalDetails.images.length < 5 && walletWithdrawalDetails.status_name !== '已转账'">
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip" style="line-height: 20px;">{{ generateCustomizeString('uploadAlert') }}</div>
        </el-upload>
      </div>
      <div style="margin-top: 50px;" v-if="walletWithdrawalDetails.status_name !== '已转账'">
        <el-button @click="viewDetailsDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateWithdrawal()">更新</el-button>
      </div>
      <div style="margin-top: 50px;" v-else>
        <el-button @click="viewDetailsDialogVisible = false">关 闭</el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="withdrawDialogVisible" title="申请提现" style="margin-bottom: 20px;">
      <el-form ref="form" :model="withdrawForm" label-width="68px">
        <div class="grid-content" style="margin-bottom: 10px; font-weight: bold;">
          <span class="title-label">可提现金额: </span>
          <span class="content-label">NZD ${{ can_withdrawal_balance }}</span>
        </div>
        <p style="font-size: 14px; color: red;">最低提现金额为NZD $50</p>
        <el-form-item label="提现金额" prop="amount">
          <el-input v-model="withdrawForm.amount" style="max-width: 320px;">
            <template slot="prepend">NZD $</template>
          </el-input>
        </el-form-item>
        <el-form-item label="货币" label-width="40px">
          <el-radio-group v-model="withdrawForm.currency_type">
            <el-radio label="CNY" style="width: 50px;">人民币</el-radio>
            <el-radio label="NZD" style="width: 40px;">纽币</el-radio>
            <el-radio label="AUD" style="width: 40px;">澳币</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="提现银行" prop="channel_name">
          <el-input v-model="withdrawForm.channel_name" style="max-width: 320px;"></el-input>
        </el-form-item>
        <el-form-item label="提现账户" prop="account">
          <el-input v-model="withdrawForm.account" style="max-width: 320px;"></el-input>
          <div style="padding-top: 5px; font-size: 12px; line-height: 20px;" v-if="withdrawForm.currency_type === 'CNY'">提现至支付宝请填写支付宝账号。</div>
          <div style="font-size: 12px; line-height: 20px;" v-if="withdrawForm.currency_type === 'CNY'">银行卡，请填写银行卡号。</div>
        </el-form-item>
        <el-form-item label="持卡人" prop="account_name">
          <el-input v-model="withdrawForm.account_name" style="max-width: 320px;"></el-input>
        </el-form-item>
        <el-form-item label="上传文件">
          <el-upload :data="qiniuData" :limit="5" :on-success="handleWithdrawSuccess" :on-error="handleError" :before-upload="beforeAvatarUpload" action="https://upload-z2.qiniup.com" :show-file-list="true" multiple>
            <!-- <img v-if="new_upload_url" :src="displayNewUploadUrl" class="avatar">
            <div v-else>
              <i class="el-icon-upload" />
              <div class="el-upload__text">{{ generateCustomizeString('uploadFile') }}
                <em>{{ generateCustomizeString('clickUpload') }}</em>
              </div>
            </div> -->
            <el-button size="small" type="primary" v-if="withdrawForm.upload_image_keys.length < 5">点击上传</el-button>
            <el-button size="small" type="primary" plain v-else disabled>文件数量已达</el-button>
            <div slot="tip" class="el-upload__tip" style="line-height: 20px;">{{ generateCustomizeString('uploadAlert') }}</div>
          </el-upload>
          <div style="padding-top: 5px; font-size: 12px; line-height: 20px; color: #E6A23C;">请上传身份证明文件 (
            <el-button type="text" size="mini" @click="whyIdDialogVisible = true">为什么？</el-button>)
          </div>
          <div v-if="withdrawForm.currency_type === 'CNY'">
            <div class="upload-tip">中华人民共和国居民身份证，或</div>
            <div class="upload-tip">中华人民共和国因私护照。</div>
          </div>
          <div v-else-if="withdrawForm.currency_type === 'NZD'">
            <div class="upload-tip">New Zealand Passport, or</div>
            <div class="upload-tip">New Zealand Driver License, or</div>
            <div class="upload-tip">New Zealand 18+ Card, and</div>
            <div class="upload-tip">有效期至少6个月之内的水，电账单</div>
          </div>
          <div v-else-if="withdrawForm.currency_type === 'AUD'">
            <div class="upload-tip">Australian Passport, or</div>
            <div class="upload-tip">Australian Driver License, and</div>
            <div class="upload-tip">有效期至少6个月之内的水，电账单</div>
          </div>
          <div>
            <el-button type="text" size="mini" @click="viewExampleDialogVisible = true">查看范例</el-button>
          </div>
        </el-form-item>
        <!-- <span>注: 提现服务由IEMONEY提供, 手续费将在转账时自动扣除, 最终解释权归IEMONEY所有 </span> -->
      </el-form>
      <div style="margin-top: 50px;">
        <el-button @click="withdrawDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="createWalletWithdrawal()">提交</el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="whyIdDialogVisible" title="为什么提供身份证明文件？" style="margin-bottom: 20px; line-height: 18px;">
      <div>为了更好的提供资金管理服务，保护您的资金安全，并防止跨境洗钱等行为，提现的银行账户需要进行实名认证。</div>
      <div>
        <ul>
          <li>在提现的时候，您需要上传相应的认证材料，工作人员会进行审核，审核通过后提现</li>
          <li>审核通过的银行帐号第二次提现无需重新审核</li>
          <li>提交新的提现地址，需要重新审核</li>
        </ul>
      </div>
      <div style="margin-top: 20px;">实名认证包括两部分，分别是用户身份认证和住址认证:</div>
      <div style="margin-top: 10px;">1. 身份认证有效证件</div>
      <ul>
        <li>中华人民共和国居民身份证</li>
        <li>中华人民共和国因私护照</li>
        <li>Australian Passport</li>
        <li>Australian Driver License</li>
        <li>New Zealand Passport</li>
        <li>New Zealand Driver License</li>
        <li>New Zealand 18+ Card</li>
      </ul>
      <div>2. 住址认证（仅限海外用户，中国地区免住址认证）</div>
      <ul>
        <li>有效期至少6个月之内的水，电，账单</li>
      </ul>
      <div style="margin-top: 30px;">
        <el-button type="primary" @click="whyIdDialogVisible = false">知道了</el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="viewExampleDialogVisible" title="实名认证的材料样例" width="90%" style="margin-bottom: 20px;">
      <div>(请确保照片清晰易识别，否则您可能需要重新上传)</div>
      <div style="margin-top: 20px; font-weight: bold;">认证国内银行账户或支付宝</div>
      <el-row :gutter="10" style="padding-top: 10px; margin-bottom: 20px;">
        <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
          <img src="/example/cn_id.jpg" style="width: 100%;">
          <div class="img-example">中华人民共和国居民身份证</div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
          <img src="/example/cn_ps.jpg" style="width: 100%;">
          <div class="img-example">中华人民共和国因私护照</div>
        </el-col>
      </el-row>
      <div style="font-weight: bold;">新西兰银行账户身份认证材料</div>
      <el-row :gutter="10" style="padding-top: 10px; margin-bottom: 20px;">
        <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
          <img src="/example/nz_ps.jpg" style="width: 100%;">
          <div class="img-example">New Zealand Passport</div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
          <img src="/example/nz_dl.jpg" style="width: 100%;">
          <div class="img-example">New Zealand Driver License</div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
          <img src="/example/nz_18.jpg" style="width: 100%;">
          <div class="img-example">New Zealand 18+ Card</div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
          <img src="/example/nz_ad.png" style="width: 100%;">
          <div class="img-example">New Zealand Electricity Bill</div>
        </el-col>
      </el-row>
      <div style="font-weight: bold;">澳洲银行账户身份认证材料</div>
      <el-row :gutter="10" style="padding-top: 10px; margin-bottom: 20px;">
        <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
          <img src="/example/au_ps.jpg" style="width: 100%;">
          <div class="img-example">Australian Passport</div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
          <img src="/example/au_dl.jpg" style="width: 100%;">
          <div class="img-example">Australian Driver License</div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
          <img src="/example/au_ad.jpg" style="width: 100%;">
          <div class="img-example">Australia Electricity Bill</div>
        </el-col>
      </el-row>
      <div style="margin-top: 10px;">
        <el-button type="primary" @click="viewExampleDialogVisible = false">知道了</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import request from '@/utils/request'
import dayjs from 'dayjs'

export default {
  name: 'WalletList',
  data() {
    return {
      listLoading: false,
      uploadLoading: false,
      currentPage: 1,
      currentTotal: 0,
      numOfMembers: 15,
      viewDetailsDialogVisible: false,
      withdrawDialogVisible: false,
      whyIdDialogVisible: false,
      viewExampleDialogVisible: false,
      balance: null,
      can_withdrawal_balance: null,
      walletTransactionData: [],
      walletWithdrawalDetails: {},
      currency: '1',
      isMobile: false,
      upload_qiniu_res_key: '',
      upload_url: '',
      new_upload_qiniu_res_key: '',
      new_upload_url: '',
      imageKeyList: [],
      qiniuData: {
        token: ''
      },
      withdrawForm: {
        currency_type: '',
        amount: '',
        channel_name: '',
        account: '',
        account_name: '',
        upload_image_keys: []
      }
    }
  },
  computed: {
    displayUploadUrl() {
      return (
        this.upload_url + '?imageView2/0/w/360/h/180/q/75|imageslim'
      )
    },
    displayNewUploadUrl() {
      return (
        this.new_upload_url + '?imageView2/0/w/360/h/180/q/75|imageslim'
      )
    }
  },
  created() {
    this.checkMobile()
    this.fetchUploadToken()
    this.fetchWalletData()
    this.fetchWalletTransactions()
  },
  methods: {
    generateCustomizeString,
    checkMobile() {
      if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
        this.isMobile = true
      }
    },
    clickView(row) {
      this.viewDetailsDialogVisible = true
      this.walletWithdrawalDetails = row.wallet_withdrawal_application
      console.log(this.walletWithdrawalDetails)
      // this.uploadForm.username = this.walletData[index].username
    },
    handleAvatarSuccess(res, file) {
      // 上传成功后在图片框显示图片
      // 更改了key
      this.upload_qiniu_res_key = res.key
      this.upload_url = 'https://id.nzmai.com.cn/' + res.key

      request({
        url: '/get-private-url',
        method: 'get',
        params: {
          base_url: 'https://id.nzmai.com.cn/' + res.key
        }
      })
        .then(res => {
          this.upload_url = res.data.image_url
          this.walletWithdrawalDetails.images.push({ 'image_url': this.upload_url, 'qiniu_res_key': this.upload_qiniu_res_key })
          this.uploadLoading = false
        })
        .catch(error => {
          console.log(error)
        })

      console.log(this.walletWithdrawalDetails.images)
    },
    handleWithdrawSuccess(res, file) {
      // 上传成功后在图片框显示图片
      // 更改了key
      this.new_upload_qiniu_res_key = res.key
      this.new_upload_url = 'https://id.nzmai.com.cn/' + res.key

      this.withdrawForm.upload_image_keys.push(res.key)
      console.log(res)
    },
    handleError(res) {
      // 显示错误
      console.log(res)
    },
    beforeAvatarUpload(file) {
      this.uploadLoading = true
      // 在图片提交前进行验证
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 4

      if (!isJPG && !isPNG) {
        this.$message.error('上传头像图片只能是 JPG/PNG 格式!')
        this.uploadLoading = false
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
        this.uploadLoading = false
      }

      return (isJPG || isPNG) && isLt2M
    },
    fetchUploadToken() {
      request({
        url: '/upload-private-token',
        method: 'get'
      })
        .then(res => {
          this.qiniuData.token = res.data['token']
        })
        .catch(error => {
          console.log(error)
        })
    },
    handleCurrentChange(val) {
      this.fetchWalletTransactions(val)
    },
    delClick(index) {
      this.walletWithdrawalDetails.images.splice(index, 1)
    },
    fetchWalletData() {
      if (this.listLoading) return
      this.listLoading = true

      request({
        url: '/agent/wallet',
        method: 'get'
      })
        .then(res => {
          if (res.status === 0) {
            this.balance = parseFloat(res.data.balance / 100).toFixed(2)
            this.can_withdrawal_balance = parseFloat(res.data.can_withdrawal_balance / 100).toFixed(2)
          }
          this.listLoading = false
        })
        .catch(error => {
          console.log(error)
          this.listLoading = false
        })
    },
    fetchWalletTransactions(page) {
      request({
        url: '/agent/wallet/transactions',
        method: 'get',
        params: {
          page: page,
          page_size: this.numOfOrders
        }
      })
        .then(res => {
          const meta = res.meta
          this.walletTransactionData = res.data
          for (var i = 0; i < this.walletTransactionData.length; i++) {
            this.walletTransactionData[i].created_at = this.walletTransactionData[i].created_at.replace(/-/g, '/')
            this.walletTransactionData[i].created_at = dayjs(new Date(this.walletTransactionData[i].created_at + ' UTC')).format('YYYY-MM-DD HH:mm:ss')
          }
          this.currentPage = meta.current_page
          this.currentTotal = meta.total
        })
        .catch(error => {
          console.log(error)
        })
    },
    createWalletWithdrawal() {
      var data = {
        amount: this.withdrawForm.amount * 100,
        currency_type: this.withdrawForm.currency_type,
        channel_name: this.withdrawForm.channel_name,
        account: this.withdrawForm.account,
        account_name: this.withdrawForm.account_name,
        upload_image_keys: this.withdrawForm.upload_image_keys
      }
      request({
        url: '/agent/wallet/withdrawal',
        method: 'post',
        data
      })
        .then(res => {
          if (res.status === 0) {
            this.$message({
              message: '申请提现成功，等待审核',
              type: 'success',
              center: true
            })
            this.withdrawDialogVisible = false
            this.fetchWalletTransactions(1)
            this.fetchWalletData()
          } else {
            this.$message.error({
              message: res.error,
              center: true
            })
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error('申请提现失败')
        })
    },
    updateWithdrawal() {
      for (var i = 0; i < this.walletWithdrawalDetails.images.length; i++) {
        this.imageKeyList.push(this.walletWithdrawalDetails.images[i].qiniu_res_key)
      }
      var data = {
        upload_image_keys: this.imageKeyList,
        wallet_withdrawal_applications_id: this.walletWithdrawalDetails.id
      }
      request({
        url: '/agent/wallet/withdrawal/images',
        method: 'patch',
        data
      })
        .then(res => {
          if (res.status === 0) {
            this.$message({
              message: '更新申请提现文件成功',
              type: 'success',
              center: true
            })
          } else {
            this.$message.error({
              message: '更新申请提现文件失败',
              center: true
            })
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error({
            message: '更新申请提现文件失败',
            center: true
          })
        })
    }
  }
}
</script>

<style type="text/css">
.el-upload-dragger {
  width: 230px;
  height: 150px;
}
</style>

<style rel="stylesheet/scss" lang="scss" scoped>
.grid-content {
  min-height: 30px;
  margin: 0 auto;
  flex: auto;
  overflow: auto;
  -webkit-align-items: center;
  align-items: center;
}
.title-label {
  display: inline-block;
  text-align: left;
  // width: 80px;
}
.content-label {
  padding: 0px 0px 0px 10px;
}
.upload-tip {
  font-size: 12px;
  line-height: 20px;
}
.img-example {
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  margin-bottom: 20px;
}
</style>
<style type="text/css">
  .el-dialog {
    width: 50%;
  }
  @media only screen and (max-width: 576px) {
    .el-dialog {
      width: 90%;
    }
  }
</style>
